export const USER_PUBLIC_PROFILE_F_REQUEST = 'user_public_profile_f_request';
export const USER_PUBLIC_PROFILE_F_SUCCESS = 'user_public_profile_f_success';
export const USER_PUBLIC_PROFILE_F_FAILURE = 'user_public_profile_f_failure';


export const USER_GIT_REPO_FETCH_REQUEST = 'user_git_repo_fetch_request';
export const USER_GIT_REPO_FETCH_SUCCESS = 'user_git_repo_fetch_success';
export const USER_GIT_REPO_FETCH_FAILURE = 'user_git_repo_fetch_failure';
